<div class="search-container" [class.with-selector]="searchTypeOptions?.length">
    <mat-form-field
        *ngIf="searchTypeOptions?.length"
        class="search-type-selector"
        subscriptSizing="dynamic"
    >
        <span class="prefix" matPrefix *ngIf="searchTypeControl.value">By: </span>
        <mat-select
            [formControl]="searchTypeControl"
            class="type-select"
            placeholder="By"
            [panelWidth]="null"
        >
            <mat-option *ngFor="let option of searchTypeOptions" [value]="option.id">
                {{ option.displayName }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic" class="search-input-field">
        <mat-label>{{ placeholder }}</mat-label>
        <input matInput type="text" [formControl]="filterControl" />
        <button
            *ngIf="filterControl.value"
            mat-icon-button
            matSuffix
            aria-label="Clear"
            (click)="onClearFilter()"
        >
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
</div>
